import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { globalProviders } from '../../../core/src/lib/constants/providers.constant';
import { BASE_PATH } from '../../../core/src/lib/api/v1';
import { SupervisorEnvironment } from '../environments/environment';
import { SupervisorAuthService } from '../../../core/src/lib/services/supervisor-auth.service';
import { NzModalService } from 'ng-zorro-antd/modal';

export const appConfig: ApplicationConfig = {
  providers: [...globalProviders, SupervisorAuthService,NzModalService,provideRouter(routes), {provide: BASE_PATH, useValue: SupervisorEnvironment.baseUrl}],
};
